import React, { useState } from 'react';
import './PageStyles.css';

export default function Contact() {
  const [form, setForm] = useState({ name:'', email:'', subject:'', message:'' });
  const [errors, setErrors] = useState({});
  const [sent, setSent] = useState(false);

  const validate = () => {
    const e = {};
    if (!form.name.trim()) e.name = 'Name is required';
    if (!form.email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) e.email = 'Valid email required';
    if (!form.subject) e.subject = 'Please select a subject';
    if (form.message.trim().length < 20) e.message = 'Message must be at least 20 characters';
    return e;
  };

  const handleChange = e => {
    setForm(f => ({...f, [e.target.name]: e.target.value}));
    if (errors[e.target.name]) setErrors(er => ({...er, [e.target.name]: ''}));
  };

  const handleSubmit = e => {
    e.preventDefault();
    const errs = validate();
    if (Object.keys(errs).length) { setErrors(errs); return; }
    setSent(true);
  };

  if (sent) return (
    <main className="inner-page">
      <div className="container" style={{display:'flex',alignItems:'center',justifyContent:'center',minHeight:'70vh'}}>
        <div className="glass-card success-box">
          <div className="success-icon">🎉</div>
          <h2>Message Sent!</h2>
          <p>Thanks <strong>{form.name}</strong>! We'll reply to <strong>{form.email}</strong> within 1–2 business days.</p>
          <button className="cta-btn" onClick={() => { setSent(false); setForm({name:'',email:'',subject:'',message:''}); }}>
            Send Another
          </button>
        </div>
      </div>
    </main>
  );

  return (
    <main className="inner-page">
      <div className="page-hero">
        <div className="container">
          <div className="page-badge">Contact</div>
          <h1>Get in <span className="accent-glow">Touch</span></h1>
          <p>Have a bug report, feature idea, or just want to say hi? We'd love to hear from you.</p>
        </div>
      </div>
      <div className="container page-content">
        <div className="content-grid">
          <div className="content-main">
            <div className="glass-card content-card">
              <h2>Send a Message</h2>
              <form onSubmit={handleSubmit} noValidate className="contact-form">
                <div className="form-row">
                  <div className={`field ${errors.name ? 'err':''}`}>
                    <label>Full Name</label>
                    <input type="text" name="name" value={form.name} onChange={handleChange} placeholder="Your name" />
                    {errors.name && <span className="field-err">{errors.name}</span>}
                  </div>
                  <div className={`field ${errors.email ? 'err':''}`}>
                    <label>Email Address</label>
                    <input type="email" name="email" value={form.email} onChange={handleChange} placeholder="you@example.com" />
                    {errors.email && <span className="field-err">{errors.email}</span>}
                  </div>
                </div>
                <div className={`field ${errors.subject ? 'err':''}`}>
                  <label>Subject</label>
                  <select name="subject" value={form.subject} onChange={handleChange}>
                    <option value="">Select a topic…</option>
                    <option value="bug">🐛 Bug Report</option>
                    <option value="feature">💡 Feature Request</option>
                    <option value="feedback">⭐ Game Feedback</option>
                    <option value="question">❓ General Question</option>
                    <option value="other">📬 Other</option>
                  </select>
                  {errors.subject && <span className="field-err">{errors.subject}</span>}
                </div>
                <div className={`field ${errors.message ? 'err':''}`}>
                  <label>Message</label>
                  <textarea name="message" value={form.message} onChange={handleChange} rows={5} placeholder="Tell us what's on your mind…" />
                  <div className="char-count">{form.message.length} / 1000</div>
                  {errors.message && <span className="field-err">{errors.message}</span>}
                </div>
                <button type="submit" className="cta-btn submit-full">Send Message 🚀</button>
              </form>
            </div>
          </div>

          <aside className="content-sidebar">
            {[
              { icon: '📬', title: 'Response Time', text: 'We typically reply within 1–2 business days. Mark your email "Urgent" for time-sensitive issues.' },
              { icon: '🐛', title: 'Bug Reports', text: 'Include your browser name, device type, and the level number where you experienced the issue.' },
              { icon: '💡', title: 'Feature Ideas', text: 'We genuinely read every suggestion. Popular requests get implemented in the next update.' },
              { icon: '🔒', title: 'Privacy', text: 'Your contact info is only used to reply to your message. We never share it with third parties.' },
            ].map((c, i) => (
              <div key={i} className="glass-card sidebar-card info-card">
                <span className="info-icon">{c.icon}</span>
                <div>
                  <div className="info-title">{c.title}</div>
                  <div className="info-text">{c.text}</div>
                </div>
              </div>
            ))}
          </aside>
        </div>
      </div>
    </main>
  );
}
